<template>
  <nav
    class="navbar navbar-default navbar-fixed-top reportNavigation"
    style="margin-top: 75px; z-index: 100"
  >
    <div class="container">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#navbar-collapse-2"
          aria-expanded="false"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>

      <div class="collapse navbar-collapse" id="navbar-collapse-2">
        <ul class="nav navbar-nav navbar-left">
          <li>
            <router-link
              to="#top"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              >Top</router-link
            >
          </li>
          <li>
            <router-link
              to="#overview"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              >Overview</router-link
            >
          </li>
          <li>
            <router-link
              to="#about"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              >About</router-link
            >
          </li>
          <li>
            <router-link
              to="#finances"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              >Finances</router-link
            >
          </li>
          <li>
            <router-link
              to="#credit"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              >Credit</router-link
            >
          </li>
          <li>
            <router-link
              to="#directors"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              >Directors</router-link
            >
          </li>
          <li>
            <router-link
              to="#locations"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
              >Locations</router-link
            >
          </li>
          <!-- <li>
            <router-link
              to="#notes"
              v-smooth-scroll="{ duration: this.scrollDuration, offset: this.scrollOffset }"
            >Notes</router-link
            >
          </li> -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      scrollOptions: {
        duration: this.scrollDuration,
        offset: this.scrollOffset,
      },
      scrollOffset: -120,
      scrollDuration: 1000,
    };
  },
};
</script>

<style>
.navbar-default.reportNavigation {
  background-color: #4b8acc;
  margin-top: 0px;
  /* padding-left: 65px; */
  padding-top: 0px;
  padding-bottom: 0px;
  min-height: 25px;
}

.navbar-default.reportNavigation > .open {
  padding-left: 0px !important;
}

.navbar-default.reportNavigation .navbar-nav > li > a:hover {
  color: #ccc;
}
</style>
